/**
 * @fileoverview added by tsickle
 * Generated from: models/office-hours.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { toTime } from '../util/datetime/index';
import { model } from '../util/model';
/**
 * @record
 */
function BaseOfficeHours() { }
if (false) {
    /** @type {?|undefined} */
    BaseOfficeHours.prototype.end;
    /** @type {?|undefined} */
    BaseOfficeHours.prototype.start;
}
/**
 * @record
 */
function OfficeHoursModelMixin() { }
if (false) {
    /**
     * Returns true if the given time is _strictly_ within the start and end time of the office hours.
     * @type {?}
     */
    OfficeHoursModelMixin.prototype.isOpen;
}
/**
 * Model representing Housekeep office hours for support requests.
 * @record
 */
export function OfficeHours() { }
/**
 * Model representing Housekeep office hours for support requests.
 * @type {?}
 */
export var officeHours = model.extend((/** @type {?} */ ({
    modelName: 'officeHours',
    isOpen: /**
     * @param {?} time
     * @return {?}
     */
    function (time) {
        time = toTime(time);
        return this.start && this.end && time.isAfter(this.start) && time.isBefore(this.end);
    }
})));
